// common
import React, { useState } from "react"
import classNames from "classnames"

// style
import styles from "./style"
import Button from "../button"

// Props Interface
interface Props {
  className?: any
  innerClassName?: any
  selectClassName?: any
  placeholder?: any
  value?: any
  secure?: boolean
  submitBtnText?: string
  onSubmit?: () => void
  onChange?: any
  onChangeMode?: any
  bottomLine?: boolean
  bordered?: boolean
  width?: number | string
  height?: number | string
  textAlign?: any
  unit?: any
  description?: string
  defaultValue?: any
  disabled?: boolean
  textContentType?: string | undefined

  options?: any
  selected?: any

  inputFieldContainerStyle?: any
  innerStyle?: any
  inputStyle?: any
  mask?: any
  margin?: number | any
  marginBottom?: number | any
  marginRight?: number | any
  maxLength?: number | any
}

export const SELECT_ON_CHANGE_MODES = {
  VALUE: "VALUE",
  NAME: "NAME",
}

const Select: React.FunctionComponent<Props> = (props: Props) => {
  const [isFocused, setIsFocused] = useState(false)

  const onBlur = () => {
    setIsFocused(false)
  }

  const onFocus = () => {
    setIsFocused(true)
  }

  const margin = props.margin !== undefined ? { margin: props.margin } : null
  const marginBottom =
    props.marginBottom !== undefined ? { marginBottom: props.marginBottom } : styles.defaultMarginBottom
  const marginRight = props.marginRight ? { marginRight: props.marginRight } : {}

  const bordered = props.bordered ? styles.inputFieldBorder : null
  const width = props.width ? { width: props.width } : { width: "100%" }
  const height = props.height ? { height: props.height } : {}
  const textAlign = props.textAlign ? { textAlign: props.textAlign } : null

  const focused = isFocused ? styles.inputFieldFocused : null

  const bottomLine = props.bottomLine === false ? null : styles.inputFieldBottomLine

  const renderDescription = () => {
    if (!props.description) {
      return null
    }

    return <span style={styles.descriptionText}>{props.description}</span>
  }
  const submitBtn = () => {
    if (!props.submitBtnText) {
      return null
    }

    return (
      <>
        <div style={styles.submitButtonContainer}>
          <Button text={props.submitBtnText} />
        </div>
      </>
    )
  }

  const renderUnit = () => {
    if (!props.unit) {
      return null
    }

    return (
      <div style={styles.unitContainer}>
        <span
          style={{
            ...styles.unitText,
            ...styles.inputField,
            ...textAlign,
          }}
        >
          {props.unit}
        </span>
      </div>
    )
  }

  return (
    <div className={`${props.className ?? ""}`} style={props.className ? null : styles.container}>
      <div
        style={{
          ...styles.inputFieldContainer,
          ...focused,
          ...width,
          ...height,
          ...margin,
          ...marginBottom,
          ...marginRight,
          ...bottomLine,
          ...focused,
          ...bordered,
          ...props.inputFieldContainerStyle,
        }}
      >
        <div className={props.innerClassName ?? ""} style={{
          ...styles.inner,
          ...props.innerStyle,
        }}>
          <select
            className={classNames([
              "bg-transparent w-full h-full",
              props.selectClassName ? props.selectClassName : props.className ? props.className : "py-3 px-2 pr-10",
              props.value ? "" : "text-gray-400",
            ])}
            value={props.value}
            onChange={(event) => {
              props.onChange(event.target.value)
            }}
          >
            {props.placeholder && (
              <option value="" disabled selected style={{ color: "#808080" }}>
                {props.placeholder}
              </option>
            )}
            {props.options?.length ? (
              props.options?.map((option, i) => {
                if (props.onChangeMode === SELECT_ON_CHANGE_MODES.VALUE) {
                  return (
                    <option key={i} value={option.value}>
                      {option.name ?? ""}
                    </option>
                  )
                }
                return <option key={i}>{option.name ?? ""}</option>
              })
            ) : (
              <></>
            )}
          </select>
          {renderUnit()}
          {submitBtn()}
        </div>
      </div>
      {renderDescription()}
    </div>
  )
}

export default Select
